import React, { FunctionComponent, useState, useEffect } from 'react';
import { ICommonComponentEditorProps } from '../../ComponentType';
import { InputNumber } from 'primereact/inputnumber';

type AlertFanEditorProps = {
    itemsPerPage?: number;
    updateFrequency?: number;
};

const defaultAlertFanConfig: AlertFanEditorProps = {
    itemsPerPage: undefined,
    updateFrequency: undefined,
};

function AlertFanEditor({ config, onConfigChange }: ICommonComponentEditorProps) {
    let conf: AlertFanEditorProps = config ?? defaultAlertFanConfig;

    if (Object.keys(conf).length === 0) {
        conf = defaultAlertFanConfig;
    }

    const [currentConfig, setCurrentConfig] = useState(conf);

    useEffect(() => {
        onConfigChange(currentConfig);
    }, [currentConfig]);

    const setConfigPropertyState = (property: keyof AlertFanEditorProps, value: any) => {
        setCurrentConfig((prevState) => ({ ...prevState, [property]: value }));
    };

    const handleConfigChange = (e: any): void => {
        setConfigPropertyState(e.target.id as keyof AlertFanEditorProps, e.value);
    };

    return (
        <div className={'grid'}>
            <div className={` col-6 flex flex-column gap-2`}>
                <label htmlFor='itemsPerPage'>Items Per Page</label>
                <InputNumber id='itemsPerPage' value={conf.itemsPerPage} onValueChange={handleConfigChange} />
            </div>
            <div className={`col-6 flex flex-column gap-2`}>
                <label htmlFor='updateFrequency'>Update Frequency</label>
                <InputNumber id='updateFrequency' value={conf.updateFrequency} onValueChange={handleConfigChange} />
            </div>
        </div>
    );
}

export default AlertFanEditor as FunctionComponent;
